import standardReport from './standardReport'
import insertionOrders from '@/vuex/modules/advertiser/insertionOrders/index'
import creative from './creative'
import reportIntervalReport from './report/IntervalReport'

export default {
  namespaced: true,
  modules: {
    insertionOrders,
    creative,
    standardReport,
    reportIntervalReport,
  },
}
